import { ArrowRight, CheckCircle, Bot, Users } from "lucide-react"
import { Button } from "~/components/ui/button"

interface HeroSectionProps {
  onContactClick: () => void
}

export function HeroSection({ onContactClick }: HeroSectionProps) {
  return (
    <section className="w-full bg-white py-16 md:py-20 lg:py-24">
      <div className="container px-4 md:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-8 text-center max-w-4xl mx-auto">
          <div className="space-y-6">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 leading-tight tracking-tight text-balance">
              Build Faster. Automate More. Hire Less.
            </h1>
            <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto text-balance">
              We help startups and teams ship products, automate workflows, and scale without the hiring drag.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 pt-2">
            <Button
              onClick={onContactClick}
              size="lg"
              className="hover:opacity-90 text-white px-8 font-semibold"
              style={{ backgroundColor: "#ed2132" }}
            >
              Book a Call
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button
              onClick={onContactClick}
              size="lg"
              variant="outline"
              className="border-slate-300 text-slate-900 hover:bg-slate-50 px-8 font-semibold"
            >
              See How We Work
            </Button>
          </div>

          <p className="text-sm text-slate-500 pt-2">10+ years building production apps in Silicon Valley</p>

          <div className="flex flex-wrap justify-center gap-4 pt-2">
            <div className="flex items-center gap-2 text-sm text-slate-600">
              <CheckCircle className="h-4 w-4" style={{ color: "#ed2132" }} />
              <span>MVPs in 30 days</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-slate-600">
              <Bot className="h-4 w-4" style={{ color: "#ed2132" }} />
              <span>AI automation</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-slate-600">
              <Users className="h-4 w-4" style={{ color: "#ed2132" }} />
              <span>Senior engineers</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
